export const TOKEN_STORAGE_KEY = "smartsetter.client-portal.token"
export const ACTIVE_ACCOUNT_ID_STORAGE_KEY =
  "smartsetter.client-portal.active_account_id"

let customerLoginRedirectStarted = false

export function resetCustomerLoginRedirectState() {
  customerLoginRedirectStarted = false
}

export function isCustomerSessionExpiredError(error) {
  if (error?.response?.status !== 401) {
    return false
  }
  const requestUrl = String(error?.config?.url || "")
  if (
    requestUrl.includes("/clients/api/login/") ||
    requestUrl.includes("/clients/api/staff/login/")
  ) {
    return false
  }
  const detail = String(
    error?.response?.data?.detail || error?.response?.data || ""
  )
  if (/no active access/i.test(detail)) {
    return false
  }
  return true
}

export function redirectToCustomerLoginOnExpiredSession() {
  if (typeof window === "undefined") {
    return
  }
  const path = window.location.pathname || ""
  if (path.startsWith("/user/log-in") || path.startsWith("/admin/log-in")) {
    return
  }
  if (customerLoginRedirectStarted) {
    return
  }
  customerLoginRedirectStarted = true
  localStorage.removeItem(TOKEN_STORAGE_KEY)
  localStorage.removeItem(ACTIVE_ACCOUNT_ID_STORAGE_KEY)
  const next = `${window.location.pathname || ""}${
    window.location.search || ""
  }`
  window.location.assign(`/user/log-in/?next=${encodeURIComponent(next)}`)
}

export function attachCustomerAuthInterceptor(client) {
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isCustomerSessionExpiredError(error)) {
        redirectToCustomerLoginOnExpiredSession()
      }
      return Promise.reject(error)
    }
  )
  return client
}
